import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_BEGIN,
  COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_SUCCESS,
  COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_FAILURE,
  COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
export function deleteCollectionValidationRules(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_BEGIN,
    });

    const { projectId, collectionUuid, validationId, version, ruleId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/validations/${collectionUuid}/collection/${validationId}/rule/${ruleId}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_SUCCESS,
              data: res.data,
              collectionUuid,
            });
            Mixpanel.track('Deleted collection validation rules');
            toast.success('Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to delete collection validation rules');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Deletion failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to delete collection validation rules');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Deletion Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}
export function dismissDeleteCollectionValidationRulesError() {
  return {
    type: COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_BEGIN:
      return {
        ...state,
        deleteCollectionValidationRulesPending: true,
        deleteCollectionValidationRulesError: null,
      };

    case COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.uuid === action.collectionUuid;
      });
      if (index !== -1) {
        projectCollections[index].validations = action.data;
      }
      return {
        ...state,
        deleteCollectionValidationRulesPending: false,
        deleteCollectionValidationRulesError: null,
        projectCollections,
        selectedCollection: {
          ...state.selectedCollection,
          validations: action.data,
        },
      };

    case COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_FAILURE:
      return {
        ...state,
        deleteCollectionValidationRulesPending: false,
        deleteCollectionValidationRulesError: action.data.error,
      };

    case COLLECTIONS_DELETE_COLLECTION_VALIDATION_RULES_DISMISS_ERROR:
      return {
        ...state,
        deleteCollectionValidationRulesError: null,
      };

    default:
      return state;
  }
}
